import React from 'react';
import Decimal from 'decimal.js';
import { OracleQuote, TokenInfo } from '../types';

interface Props {
    quotes: OracleQuote[];
    coins: TokenInfo[];
}

function fmt(s: string) {
    try {
        return new Decimal(s).toSignificantDigits(6).toString();
    } catch {
        return s;
    }
}
function sym(addr: string, coins: TokenInfo[]) {
    const c = coins.find((c) => c.address.toLowerCase() === addr.toLowerCase());
    return c ? c.symbol : addr.slice(0, 8);
}

export default function OracleTable({ quotes, coins }: Props) {
    return (
        <div className="card">
            <h2>Oracle Prices</h2>
            <table>
                <thead>
                    <tr>
                        <th>Token</th>
                        <th>Buy</th>
                        <th>Sell</th>
                        <th>Producer ts</th>
                        <th>Quoted at block</th>
                        <th>Status</th>
                        <th>Updated</th>
                    </tr>
                </thead>
                <tbody>
                    {quotes.length === 0 && (
                        <tr>
                            <td colSpan={7} className="empty">
                                no oracle data
                            </td>
                        </tr>
                    )}
                    {quotes.map((q) => (
                        <tr key={`${q.dex}-${q.token}`}>
                            <td>{sym(q.token, coins)}</td>
                            <td>{fmt(q.buy)}</td>
                            <td>{fmt(q.sell)}</td>
                            <td>{q.quotedAtUs}</td>
                            <td>{q.quotedAtBlock}</td>
                            <td>{!q.active ? 'inactive' : q.fresh ? 'active' : 'stale'}</td>
                            <td>{new Date(q.updated_at).toLocaleTimeString()}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
